module.exports = __webpack_public_path__ + "img/596773_B3C6CE_98AFB9_879AA8-256px.41de1e64.png";